import anime from 'animejs'

export function translate(element) {
    const animation = anime({
        targets: element,
        width: '100%',
        direction: 'alternate',
        backgroundColor: 'orange',
        easing: 'linear',
        autoplay: false,
        update: (anim) => {

        }
    });
    return animation;
}
